'use client';
import { useId, useState, type ReactNode } from 'react';
import { IconChevronDown } from '@tabler/icons-react';
import s from './rich-bio.module.css';
import './bio-motion.css';

export function BioDrawer({
  className,
  heading,
  children,
}: {
  className?: string;
  heading: ReactNode;
  children: ReactNode;
}) {
  const [open, setOpen] = useState(false);
  const id = useId();
  return (
    <div className={`t-acc ${className}`} data-open={open}>
      <button
        type="button"
        className={`t-acc-head ${s.drawerHead}`}
        aria-expanded={open}
        aria-controls={id}
        onClick={() => setOpen(!open)}
      >
        {heading}
        <IconChevronDown className="t-acc-chevron" size={18} aria-hidden />
      </button>
      <div id={id} className="t-acc-panel" aria-hidden={!open} inert={!open}>
        <div className="t-acc-panel-inner">{children}</div>
      </div>
    </div>
  );
}
